type Handler = () => void;

const listeners = new Set<Handler>();

export const orderEvents = {
  /** Fire this after an order is successfully created. */
  emit(): void {
    listeners.forEach((handler) => {
      try {
        handler();
      } catch (err) {
        console.error("[orderEvents] listener threw", err);
      }
    });
  },

  /**
   * Subscribe to order-created events.
   * Returns an unsubscribe function (returns void, safe for useEffect cleanup).
   */
  on(handler: Handler): () => void {
    listeners.add(handler);
    return () => {
      listeners.delete(handler);
    };
  },
};